
import Campaignlistplaceholder from "~/components/placeholders/campaignlistplaceholder";
import Foot from "~/layouts/foot";
export default {
  name: "index",
  head() {
    return {
      title: 'Kαμπάνιες',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: "Lastik satın alırken Servislet kampanyaları ve promosyanları ile indirimli satın alın"
        },
        { hid: 'keywords', name: 'keywords', content: "lastik kampanyaları, lastik promosyonları, kuponlar, indirim, servislet, satın al, indirimli"}
      ],
    }
  },
  components: {Foot, Campaignlistplaceholder},
  async fetch() {
    try {
      var campaigns = await this.$http.$get('/cms/posts/campaign/by-type-slug?limit=100')
      this.campaigns = campaigns.data.cmsPosts.items
    }catch (e) {
      this.$router.push(this.localePath({name: 'miscellaneous-error'}))
    }
  },
  methods: {
    setTitle(title) {
      document.title = title + ' | Tirelet'
    },
  },
  data() {
    return {
      campaigns: []
    }
  }
}
